import { Theme } from '../Theme'
import { SIZES as TEXT_SIZES } from '../Typography/constants'
import { CheckboxKind } from './Checkbox'

export const SIZES = {
  MEDIUM: 'Medium',
  SMALL: 'Small',
} as const

export const VIEWBOX_MAP = {
  [SIZES.MEDIUM]: '0 0 24 24',
  [SIZES.SMALL]: '0 0 16 16',
} as const

export const TEXT_MAP = {
  [SIZES.MEDIUM]: TEXT_SIZES.S,
  [SIZES.SMALL]: TEXT_SIZES.XS,
} as const

export const POLYLINE_MAP = {
  [SIZES.MEDIUM]: '6.5,13.5 10,17 18,8.5',
  [SIZES.SMALL]: '4.3,9 6.67,11.33 12,5.67',
} as const

export const KIND = {
  DEFAULT: 'Default',
  SELECT: 'Select',
  OPTION: 'Option',
  TOGGLE: 'Toggle',
} as const

export enum Alignment {
  TOP = 'TOP',
  CENTER = 'CENTER',
}

export const CheckboxThemeKindMapping: {
  [K in Theme]?: {
    [T in CheckboxKind]?: CheckboxKind
  }
} = {
  [Theme.Pegasus]: {
    Select: 'Default',
  },
  [Theme.Kelpie]: {
    Select: 'Default',
  },
} as const
